import React from 'react';
import { Routes, Route, Navigate, Router } from 'react-router-dom';
import './App.css';
import HomeComponent from './pages/Home/HomeComponent';
import PackageDetails from './pages/Package/PackageDetails';
import TourComponent from './pages/Tour/TourComponent';
import Search from './pages/Package/Search/Search';
import LandingComponent from './pages/Landing/LandingComponent';
import ExploreComponent from './pages/Explore/ExploreComponent';
import PaymentProcess from './pages/PaymentProcess/PaymentProcess';
import BookingSummary from './pages/PaymentProcess/BookingSummary';
import GstDetailsModal from './pages/PaymentProcess/GstDetailsModal';
import Profile from './pages/Profile/Profile';
import History from './pages/History/History';
import PaymentSuccess from './pages/PaymentProcess/PaymentSuccess';
import MarketingTemplateOne from './pages/MarketingTemplate/MarketingTemplateOne';
import MarketingTemplateTwo from './pages/MarketingTemplate/MarketingTemplateTwo';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import CancellationPolicy from './pages/CancellationPolicy/CancellationPolicy';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
import AboutUs from './pages/AboutUs/AboutUs';
import PdfDownload from './components/PDFDownload/PdfDownload';
import UpcomingTripDetails from './pages/UpcomingTripsDetails/UpcomingTripsDetails';
import Blog from './pages/Blogs/Blogs';

function App() {
  return (
    <>
      <Routes>
        <Route index element={<Navigate to="/home" />} />
        <Route path="/home" element={<LandingComponent />} />
        <Route path="/explore-all" element={<HomeComponent />} />
        <Route path="/package-details/:userId" element={<PackageDetails />} />
        <Route path="/tour/:routeId" element={<TourComponent />} />
        <Route path="/explore/:tourType" element={<ExploreComponent />} />
        <Route path="/search" element={<Search />} />
        <Route path="/booking" element={<PaymentProcess />} />
        <Route path="/booking-summary" element={<BookingSummary />} />
        <Route path="/gst-details" element={<GstDetailsModal />} />
        <Route path='/profile' element={<Profile />}></Route>
        <Route path='/history' element={<History />}></Route>
        <Route path='/payment-success' element={<PaymentSuccess />}></Route>
        <Route path='/landing' element={<MarketingTemplateOne />}></Route>
        <Route path='/landing-two' element={<MarketingTemplateTwo />}></Route>
        <Route path='/privacy-policy' element={<PrivacyPolicy />}></Route>
        <Route path='/cancellation-policy' element={<CancellationPolicy />}></Route>
        <Route path="/booking" element={<PaymentProcess/>} />
        <Route path="/booking-summary" element={<BookingSummary/>} />
        <Route path="/gst-details" element={<GstDetailsModal/>} />
        <Route path='/profile' element={<Profile/>}></Route>
        <Route path='/history' element={<History/>}></Route>
        <Route path='/payment-success' element={<PaymentSuccess/>}></Route>
        <Route path='/landing' element={<MarketingTemplateOne/>}></Route>
        <Route path='/landing-two' element={<MarketingTemplateTwo/>}></Route>
        <Route path='/terms-and-conditions' element={<TermsAndConditions/>}></Route>
        <Route path='/about-us' element={<AboutUs/>}></Route>
        <Route path='/pdf-download' element={<PdfDownload/>}></Route>
        <Route path='/upcoming-trips' element={<UpcomingTripDetails/>}></Route>
        {/* <Route path='/blogs' element={<Blog/>}></Route> */}
      </Routes>
    </>
  )
}

export default App;
